import { provideState, MetaReducer, Action } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { createLocalStorageSyncReducer } from '../../shared/utils/local-storage-sync';
import { NotificationService } from './services/notification.service';
import { NotificationsEffects } from './state/effects/notifications.effects';
import { NotificationsFacade } from './facade/notification.facade';
import { NotificationsState, notificationsReducer } from './state/reducers/notifications.reducer';
import { notificationsStateKey } from './state';

const localStorageSyncReducer = createLocalStorageSyncReducer<NotificationsState>(['notifications']);

const metaReducers: Array<MetaReducer<NotificationsState, Action>> = [localStorageSyncReducer];

export const notificationsConfig = [
  provideState(notificationsStateKey, notificationsReducer, { metaReducers }),
  provideEffects([NotificationsEffects]),
  NotificationService,
  NotificationsFacade,
];
